<div [ngClass]="{ 'carousel slide': showCarousel, 'scroll-div': !showCarousel }" id="carouselExampleControls" #carousel
    class="carousel slide" data-ride="carousel">
    <div [ngClass]="{ 'carousel-inner': showCarousel, 'scroll-inner': !showCarousel }">

        <div class="d-flex gap-3 overflow-auto py-3 px-2" *ngIf="jobOpeningsRows.length === 0 && type == 'Top'">
          <div *ngFor="let loader of [1,2,3,4]" class="card skeleton-card">
            <div class="card-body">
              <div class="skeleton-logo mb-3"></div>
              <div class="skeleton-text short mb-2"></div>
              <div class="skeleton-pill mb-3"></div>

              <div class="skeleton-line mb-2"></div>
              <div class="skeleton-line mb-2"></div>
              <div class="skeleton-line mb-3"></div>

              <div class="skeleton-button"></div>
            </div>
          </div>
        </div>

        <div class="px-3 py-4" *ngIf="jobOpeningsRows.length === 0 && type != 'Top'">
          <h5 class="fw-bold mb-4">Vacantes publicadas durante el último mes</h5>

          <div *ngFor="let item of [1, 2, 3, 4]" class="d-flex align-items-start gap-3 mb-3 p-3 rounded bg-light skeleton-container">
            <div class="skeleton-logo"></div>
            <div class="flex-grow-1">
              <div class="skeleton-text title mb-2"></div>
              <div class="skeleton-line mb-1 w-50"></div>
              <div class="skeleton-line mb-1 w-25"></div>
              <div class="skeleton-line mb-1 w-25"></div>
            </div>
            <div class="d-flex flex-column align-items-end">
              <div class="skeleton-pill mb-2"></div>
              <div class="skeleton-button"></div>
            </div>
          </div>
        </div>

        <div class="container my-4" *ngIf="type != 'Top'">
          <!-- <h2 class="fw-bold text-center mb-4">Vacantes publicadas durante el último mes</h2> -->

          <ng-container *ngFor="let Row of jobOpeningsRows; let i = index" >
              <div *ngFor="let topJob of Row; let x = index" class="card mb-3 shadow-sm border-0">

                <div class="card-body d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                  <div class="d-flex align-items-start gap-3 mb-3 mb-md-0 row">
                    <div class="col-12 col-md-3">
                        <img src="/assets/img/home/Manpower/mp logo.png" alt="Logo" class="logo-vacante">
                    </div>
                    <div class="col-12">
                      <h5 class="fw-bold text-primary mb-1"> {{topJob._source.titulo_vacante | uppercase}}</h5>
                      <small class="text-muted date-info">{{topJob._source.fecha_publicacion | date:'longDate'}}</small>
                      <p class="text-muted small mb-1"><i class="bi bi-geo-alt-fill"></i> {{topJob._source.entidad_federativa | titlecase}}, {{topJob._source.pais | titlecase}}</p>
                      <p class="text-muted small mb-1"><i class="bi bi-clock-fill"></i> {{topJob._source.jornada_laboral | titlecase | formatearDias}}</p>
                      <p class="text-muted small"><i class="bi bi-card-checklist"></i> Prestaciones de {{topJob?._source?.prestaciones_laborales}}</p>
                    </div>
                  </div>

                  <div class="text-end">
                    <p class="fw-bold bg-light rounded-pill px-3 py-1 d-inline-block mb-2">
                        Sueldo mensual<br>
                        <span class="text-body">
                            ${{topJob._source.sueldo_desde | numberWithCommas}} {{'currency' | translate}}
                        </span>
                    </p><br>
                    <button (click)="redirectToSearch(topJob._source.requisicion!, topJob._source.titulo_vacante!)" class="btn btn-outline-primary btn-sm rounded-pill btn-ver-empleo">Ver empleo</button>
                  </div>
                </div>
              </div>
            </ng-container>
        </div>



        <ng-container *ngIf="type === 'Top'" >    
            <div *ngFor="let Row of jobOpeningsRows; let i = index"
                [ngClass]="{ 'carousel-item': showCarousel,'active':showCarousel && i==0, 'row-item': !showCarousel }">
                <div class="row job-card-row">
                    <div class="col-12 col-lg-3 col-mb-3 job-card-item" *ngFor="let topJob of Row; let x = index">

                        <div class="card shadow-sm rounded-3 border-0 mb-4" style="max-width: 360px;">
                          <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <img src="/assets/img/home/Manpower/mp logo.png" alt="Manpower" height="20">
                              <small class="text-muted date-info">{{topJob._source.fecha_publicacion | date:'longDate'}}</small>
                            </div>

                            <h5 class="card-title text-primary fw-bold mb-3m title-vacancy truncate-2-lines">{{topJob._source.titulo_vacante | uppercase}}</h5>

                            <div class="bg-light rounded p-2 mb-3">
                              <div class="text-muted small">Sueldo mensual</div>
                              <div class="fw-semibold">${{topJob._source.sueldo_desde | numberWithCommas}} {{'currency' | translate}}</div>
                            </div>

                            <ul class="list-unstyled small mb-4">
                              <li class="mb-1"><i class="bi bi-geo-alt-fill me-2 text-secondary"></i>{{topJob._source.entidad_federativa | titlecase}}, {{topJob._source.pais | titlecase}}</li>
                              <li class="mb-1"><i class="bi bi-calendar2-week me-2 text-secondary"></i>Horario de {{topJob._source.jornada_laboral | titlecase | formatearDias}}</li>
                              <li><i class="bi bi-briefcase me-2 text-secondary"></i>Prestaciones de {{topJob?._source?.prestaciones_laborales}}</li>
                            </ul>

                            <div class="d-grid">
                              <button (click)="redirectToSearch(topJob._source.requisicion!, topJob._source.titulo_vacante!)" class="btn btn-outline-primary w-100 fw-semibold btn-ver-empleo">
                                {{"show-bussiness-jobs" | translate}}
                            </button>
                            </div>
                          </div>
                        </div>


                        <!-- <div class="card job-card shadow-sm border-0 mb-4">
                          <div class="card-body p-4">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <img src="/assets/img/home/Manpower/mp logo.png" alt="Manpower" height="20">
                              <small class="text-muted">{{topJob._source.fecha_publicacion | date:'longDate'}}</small>
                            </div>

                            <h5 class="job-title text-primary fw-bold mb-3 truncate-2-lines">
                              {{topJob._source.titulo_vacante | uppercase}}
                            </h5>

                            <div class="salary-badge mb-3">
                                Sueldo mensual 
                              ${{topJob._source.sueldo_desde | currency:'MXN':'symbol':'1.0'}} - ${{topJob._source.sueldo_hasta | currency:'MXN':'symbol':'1.0'}}
                            </div>

                            <ul class="list-unstyled text-muted small mb-2">
                              <li class="mb-1">
                                <i class="bi bi-geo-alt-fill me-1"></i> {{topJob._source.entidad_federativa | titlecase}}, {{topJob._source.pais | titlecase}}
                              </li>
                              <li class="mb-1">
                                <i class="bi bi-briefcase-fill me-1"></i> Horario de {{topJob._source.jornada_laboral | titlecase}}
                              </li>
                              <li>
                                <i class="bi bi-building me-1"></i> Prestaciones de {{topJob?._source?.prestaciones_laborales}}
                              </li>
                            </ul>

                            <button (click)="redirectToSearch(topJob._source.requisicion!, topJob._source.titulo_vacante!)" class="btn btn-outline-primary w-100 fw-semibold btn-ver-empleo">
                                {{"show-bussiness-jobs" | translate}}
                            </button>
                          </div>
                        </div> -->

                        <!-- <div class="mat-card-job" appearance="outlined">
                            <div class="card-body">
                                <div class="job-section">
                                    <div class="flex-row">
                                        <span class="job-brand">
                                            <img src="/assets/img/home/Manpower/mp logo.png">
                                            <small class="job-date">{{topJob._source.fecha_publicacion | date:'longDate'}}</small>
                                        </span>
                                    </div>
                                    <div class="col-12">
                                        <div class="label-bold">

                                            <h1 class="job-title text-break ellipsis-2-lines">{{topJob._source.titulo_vacante | uppercase}}</h1>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="text-end">
                                            <span class="job-salary">${{topJob._source.sueldo_rango}}</span>
                                        </div>
                                    </div>
                                    <div class="col-12 job-location">
                                        <p>
                                            <i class="bi bi-geo-alt-fill"></i> {{topJob._source.entidad_federativa | titlecase}}, {{topJob._source.pais | titlecase}}
                                        </p>

                                        <p><i class="bi bi-suitcase-lg-fill"></i> Horario de {{topJob._source.jornada_laboral | titlecase}}</p>

                                        <div class="job-salarya">
                                            <i class="bi bi-buildings"></i> Prestaciones {{topJob?._source?.prestaciones_laborales}}
                                        </div>
                                    </div>

                                </div>
                                <div class="action-job-opening">
                                    <button (click)="redirectToSearch(topJob._source.requisicion!, topJob._source.titulo_vacante!)"
                                        class=" btn  btn-outline-primary btn-show-job-opening">{{"show-bussiness-jobs" |
                                        translate}}</button>

                                </div>
                            </div>

                        </div> -->

                    </div>
                </div>

            </div>
        </ng-container>

    </div>

    <a *ngIf="showCarousel" class="carousel-control-prev" data-bs-target="#carouselExampleControls"
        href="#carouselExampleControls" role="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a *ngIf="showCarousel" class="carousel-control-next" data-bs-target="#carouselExampleControls"
        href="#carouselExampleControls" role="button" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>